// App Constants
export const APP_NAME = 'wybli';
export const APP_DISPLAY_NAME = 'wybli';
export const APP_DESCRIPTION = 'A revolutionary social platform that brings people together through immersive avatar-based video chatting.'; 